<script>
    import Spinner from '../../Spinner.svelte';
    import { sgettext } from '../../../i18n.js';

    import Comment from './Comment.svelte';

    export let comments = [];
    export let loading;
</script>

<style>
    .comments {
        max-height: 250px;
        overflow-y: auto;
        margin-bottom: 1.5em;
    }
</style>

{#if loading}
<div class="justify-content-center">
    <Spinner />
</div>
{/if}

{#if !comments.length && !loading}
    <h4>{sgettext('$$COMMENTS_2$$')}</h4>
{/if}

<div class="comments">
    <div class="list-group" data-testid="comments-list">

        {#each comments as comment}
        <div class="list-group-item" data-testid="comments-list-item">
            <Comment data={comment} />
        </div>
        {/each}
    </div>
</div>
